<template>
  <div class="form">
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               width="50%"
               top="5vh"
               :show-close="false"
               :title="title">
      <el-form label-position="top"
               :model="form"
               ref="form"
               :rules="rule"
               size="mini"
               label-width="80px">
        <el-form-item :label="$t('corpDialog.Company')"
                      v-if="isAllUser && !corpId"
                      prop="CorpId"
                      key="CorpId"
                      required>
          <el-select v-model="form.CorpId"
                     filterable
                     remote
                     size="small"
                     @change="getRoleList"
                     reserve-keyword
                     style="width:100%"
                     :remote-method="getAllCorps"
                     :loading="loading">
            <el-option v-for="item in list"
                       :key="item.CorpId"
                       :label="item.CorpName"
                       :value="item.CorpId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('corpDialog.AccountInfo')"
                      required>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item prop="LoginAccount">
                <el-input size="small"
                          :disabled="!(!this.id)"
                          v-model.trim="form.LoginAccount"
                          auto-complete="off"
                          :placeholder="$t('corpDialog.LoginAccount')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="RoleId"
                            key="RoleId">
                <el-select size="small"
                           v-model="form.RoleId"
                           clearable
                           :placeholder="$t('corpDialog.Role')"
                           :disabled="disabled || disabledRole"
                           style="width:100%">
                  <el-option v-for="i in role"
                             :value="i.RoleId"
                             :key="i.RoleId"
                             :label="$t('api.'+i.RoleName)"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('corpDialog.Password')"
                      v-if="!this.id"
                      required>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item prop="LoginPassword">
                <el-input :disabled="disabled || disabledPass"
                          size="small"
                          v-model.trim="form.LoginPassword"
                          type="password"
                          auto-complete="new-password"
                          :placeholder="$t('corpDialog.Password')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ConfirmPassword">
                <el-input :disabled="disabled || disabledPass"
                          size="small"
                          v-model.trim="form.ConfirmPassword"
                          type="password"
                          :placeholder="$t('corpDialog.ConfirmPassword')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('corpDialog.UserInfo') "
                      required>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item prop="FullName">
                <el-input :disabled="disabled || disabledPass"
                          size="small"
                          v-model="form.FullName"
                          :placeholder="$t('corpDialog.FullName')"
                          @blur="form.FullName=$event.target.value.trim()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="Phone">
                <el-input :disabled="disabled  || disabledPass"
                          size="small"
                          v-model="form.Phone"
                          :placeholder="$t('corpDialog.Phone')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="Email">
                <el-input :disabled="disabled  || disabledPass"
                          size="small"
                          v-model.trim="form.Email"
                          :placeholder="$t('corpDialog.Email')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('corpDialog.Avatar')"
                      v-if="this.id">
          <el-upload class="avatar-uploader"
                     action=""
                     accept=".jpg,.jpeg,.png"
                     :show-file-list="false"
                     :on-change="handleAvatarSuccess">
            <div v-if="avatarUrl"
                 class="logo">
              <img :src="avatarUrl"
                   class="avatar">
            </div>
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="closeDialog">{{$t('corpDialog.Cancel')}}</el-button>
        <el-button size="small"
                   :disabled="disabled"
                   type="primary"
                   @click="saveCorpUsers">{{$t('corpDialog.Save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  existCorpOrOnlySSO,
  saveCorpUsers,
  getCorpUserById,
  getAllCorps,
  getCorpUser
} from '@/api/config'
import { Upload } from '@/api/request'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    },
    corpId: {
      type: Number,
      default: null
    },
    noChangeRole: {
      type: Boolean,
      default: false
    },
    noClearForm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const account = async (rule, value, callback) => {
      if (this.id) {
        return callback()
      }
      if (value) {
        this.disabled = false
        if (!this.$config.validEmail(value)) {
          return callback(new Error(this.$t('corpDialog.Youneedtoenteravalidemail')))
        } else {
          let result = await this.existCorpOrOnlySSO(value)
          if (this.disabledPass === true) {
            this.form.FullName = ''
            this.form.Email = ''
            this.form.Phone = ''
            this.disabledPass = false
          }
          this.form.NotValidLoginAccount = false
          this.form.NotValidLoginPassword = false
          if (result.Status === 103 || result.Status === 104) {
            this.$refs['form'].clearValidate('LoginPassword')
            this.$refs['form'].clearValidate('ConfirmPassword')
            this.$refs['form'].clearValidate('Name')
          }
          if (result.Status === 103) {
            this.disabled = true
            this.$refs['form'].clearValidate('RoleId')
            return callback(new Error(this.$t('api.AccountExist')))
          } else if (result.Status === 104) {
            this.disabledPass = true
            this.form.LoginPassword = ''
            this.form.ConfirmPassword = ''
            this.form.NotValidLoginAccount = true
            this.form.NotValidLoginPassword = true
            var user = result.User
            if (user != null) {
              this.form.FullName = user.FullName
              this.form.Email = user.Email
              this.form.Phone = user.Phone
              if (user.DocFileId) {
                this.getAvatarUrl(user.DocFileId)
              }
            }
            return callback()
          } else {
            this.form.LoginAccount = value
            callback()
          }
        }
      } else {
        return callback(new Error(this.$t('corpDialog.LoginAccountisrequired')))
      }
    }
    const password = (rule, value, callback) => {
      if (value) {
        this.form.LoginPassword = value
        callback()
      } else {
        if (this.disabledPass) {
          callback()
        } else {
          return callback(new Error(this.$t('corpDialog.Passwordisrequired')))
        }
      }
    }
    const confirmPassword = (rule, value, callback) => {
      if (value) {
        if (value !== this.form.LoginPassword) {
          return callback(new Error(this.$t('corpDialog.Confirmpassworddosenotmatchpassword')))
        } else {
          this.ConfirmPassword = value
          callback()
        }
      } else {
        if (this.disabledPass) {
          callback()
        } else {
          return callback(new Error(this.$t('corpDialog.ConfirmPasswordisrequired')))
        }
      }
    }
    return {
      language: '',
      disabled: false,
      disabledPass: false,
      disabledRole: false,
      role: [],
      title: this.$t('corpDialog.AddUser'),
      form: {
        BranchId: 0,
        RoleId: '',
        FullName: '',
        Address: '',
        City: '',
        State: '',
        ZipCode: '',
        Phone: '',
        Fax: '',
        CellPhone: '',
        Email: '',
        IsEnabled: true,
        IsDeleted: false,
        IsSystem: false,
        LoginAccount: '',
        Country: '',
        LoginPassword: '',
        ConfirmPassword: '',
        NotValidLoginAccount: false,
        NotValidLoginPassword: false
      },
      rule: {
        RoleId: [{
          required: true,
          message: this.$t('corpDialog.Selectonerole'),
          trigger: 'change'
        }],
        FullName: [{
          required: true,
          message: this.$t('corpDialog.Nameisrequired'),
          trigger: 'blur'
        }],
        LoginAccount: [{
          trigger: 'blur',
          validator: account
        }],
        LoginPassword: [{
          trigger: 'blur',
          validator: password
        }],
        ConfirmPassword: [{
          trigger: 'blur',
          validator: confirmPassword
        }],
        CorpId: [{
          required: true,
          message: this.$t('corpDialog.CorpIsrequired'),
          trigger: 'blur'
        }]
      },
      avatarUrl: null,
      vatarFile: null,
      corpCondition: {
        CorpName: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'LastUpdatedOn desc'
      },
      list: [],
      loading: false,
      userList: []
    }
  },
  computed: {
    ...mapState(['userInfo']),
    isAllUser () {
      if (this.$route.name === 'allUsers') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getRoleList()
    this.getAllCorps()
  },
  mounted () {
    this.language = localStorage.language
  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.disabled = false
        this.disabledPass = false
        this.getRoleList()
        if (this.corpId) {
          this.getUser()
        }
      }
    },
    id (to, from) {
      if (to) {
        this.title = this.$t('corpDialog.EditUser')
        if (!this.noChangeRole) {
          this.getCorpUserById()
        }
      } else {
        this.title = this.$t('corpDialog.AddUser')
      }
      this.getRoleList()
    },
    noChangeRole (to, from) {
      if (to) {
        this.disabledRole = true
        this.getCorpUserById()
      }
    }
  },
  methods: {
    getUser () {
      let condition = {
        CorpId: this.corpId,
        PageIndex: 1,
        PageSize: 1000,
        OrderBy: 'LastUpdatedOn desc'
      }
      getCorpUser(condition).then(res => {
        this.userList = res.Data
      })
    },
    getAllCorps (query) {
      this.corpCondition.CorpName = query
      this.loading = true
      getAllCorps(this.corpCondition).then(res => {
        this.list = res.Data
        this.total = res.TotalCount
        this.loading = false
      })
    },
    changeLanguage () {
      localStorage.setItem('language', this.language)
      this.$store.commit('setLanguage', this.language)
      location.reload()
    },
    getCorpUserById () {
      let param = this.id
      if (this.corpId > 0) {
        param += '?corpId=' + this.corpId
      }
      let that = this
      getCorpUserById(param).then(res => {
        that.form = res
        that.avatarUrl = ''
        if (res.DocFileId && res.DocFileId.length > 0) {
          this.getAvatarUrl(res.DocFileId)
        }
      })
    },
    getAvatarUrl (id) {
      let that = this
      return axios({
        method: 'get',
        url: this.$config.baseURL + '/api/Attachments/' + id,
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res])
        let objectUrl = URL.createObjectURL(blob)
        that.avatarUrl = objectUrl
        if (that.form.UserId === that.userInfo.UserId) {
          this.$store.commit('changeAvatar', objectUrl)
        }
      })
    },
    saveCorpUsers () {
      let that = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.disabled = true
          for (let i in that.form) {
            if (i === 'LoginAccount') {
              that.form[i] = that.form[i].trim()
            }
          }
          if (that.corpId > 0) {
            that.form.CorpId = that.corpId
          }
          let fl = this.$config.getFirstLastNameByFullName(that.form.FullName)
          that.form.FirstName = fl.FirstName
          that.form.LastName = fl.LastName
          saveCorpUsers(that.form).then(async res => {
            if (that.form.UserId === this.userInfo.UserId) {
              this.$store.commit('changeName', that.form.FullName)
            }
            if (that.avatarFile) {
              that.form.UserId = res
              await this.uploadAvatar()
              await this.getAvatarUrl(that.form.DocFileId)
              this.closeDialog(true)
            } else {
              this.closeDialog(true)
            }
          }).catch(res => {
            this.disabled = false
          })
        }
      })
    },
    existCorpOrOnlySSO (value) {
      return new Promise((resolve, reject) => {
        let result = this.userList.find(item => {
          if (value === item.LoginAccount) {
            return item
          }
        })
        if (result) {
          resolve({ Status: 103 })
          return
        }
        existCorpOrOnlySSO(value).then(async res => {
          resolve(res)
        })
      })
    },
    getRoleList () {
      let condition = {
        PageIndex: 1,
        PageSize: 100,
        OrderBy: 'LastUpdatedOn desc'
      }
      if (this.isAllUser && !this.corpId) {
        condition.CorpId = this.form.CorpId
      } else {
        condition.CorpId = this.corpId
      }
      getRoleList(condition).then(res => {
        this.role = res.Data
      })
    },
    closeDialog (needRefresh) {
      this.$emit('closeDialog', needRefresh)
      if (!this.noClearForm) {
        this.$refs['form'].resetFields()
        this.form = {
          UserId: 0,
          BranchId: 0,
          RoleId: null,
          FullName: '',
          Address: '',
          City: '',
          State: '',
          ZipCode: '',
          Phone: '',
          Fax: '',
          CellPhone: '',
          Email: '',
          IsEnabled: true,
          IsDeleted: false,
          IsSystem: false,
          LoginAccount: null,
          Country: '',
          LoginPassword: null,
          ConfirmPassword: null,
          NotValidLoginAccount: false,
          NotValidLoginPassword: false,
          DocFile: 0
        }
        this.avatarUrl = ''
        this.avatarFile = null
      }
    },
    handleAvatarSuccess (res, file) {
      if (res) {
        this.avatarUrl = URL.createObjectURL(res.raw)
        this.avatarFile = res.raw
      }
    },
    uploadAvatar () {
      let that = this
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', this.avatarFile)
        formData.append('userId', this.form.UserId)
        const loading = this.$loading({
          lock: true,
          text: this.$t('welcome.Loading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        Upload('/api/CorpUsers/UploadAvatar', formData).then(result => {
          that.form.DocFileId = result
          resolve(result)
        })
        loading.close()
      })
    },
    removeAvatar (index) {
      this.avatarUrl = ''
      this.avatarFile = null
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
.form {
  .el-form {
    .el-form-item {
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 132px;
        height: 132px;
        line-height: 132px;
        text-align: center;
      }
      .avatar {
        width: 100%;
        display: block;
      }
      .logo {
        width: 132px;
        height: 132px;
        position: relative;
        overflow: hidden;
        margin: 10px 15px 0;
        float: left;
        img {
          position: absolute;
          width: 100%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          opacity: 1;
        }
      }
    }
  }
}
</style>
